import { useNavigate } from "react-router-dom";

import { RouteEnum } from "../models/enums";
import { env } from "../../configs/reexports";

export const useTargetDomain = () => {
  const navigate = useNavigate();

  const redirect = () => {
    if (window.location.hostname.includes("localhost")) {
      if (env?.stacks.webapp.domain.subdomains.length) {
        const domain = `${env.name}.${env.stacks.webapp.domain.apex}`;

        navigate(`${RouteEnum.Login}?targetDomain=${domain}`, {
          replace: true,
        });
      } else {
        navigate(RouteEnum.Login, { replace: true });
      }
    } else {
      navigate(RouteEnum.Login, { replace: true });
    }
  };

  return { redirect };
};
